@if (ComplianceSetting && Vendor && country) {
  <div class="compliance-review-body">
    <!-- Complex ownership banner — soft warning, not raw red text -->
    @if (Vendor.hasComplexOwnership) {
      <div class="row mb-3">
        <div class="col">
          <div class="owner-warning">
            <i class="bi bi-info-circle owner-warning__icon"></i>
            <span>This vendor has complex ownership.</span>
          </div>
        </div>
      </div>
    }

    <!-- Top action bar -->
    <div class="row mb-3">
      <div class="col">
        <div class="action-row justify-end">
          @if (
            MappedOwnerComplianceResults.size > 0 &&
            OwnerFormArray.controls.length > 0
          ) {
            <button
              type="button"
              class="btn btn-outline"
              (click)="runAllVerificationOnOwners()"
            >
              <i class="bi bi-shield-check me-1"></i>
              Run all public data
            </button>
          }
          <button type="button" class="btn btn-primary" (click)="addOwner()">
            <i class="bi bi-plus-lg me-1"></i>
            Add owner
          </button>
        </div>
      </div>
    </div>

    @if (
      MappedOwnerComplianceResults.size > 0 &&
      OwnerFormArray.controls.length > 0
    ) {
      <!-- One findings card per owner -->
      @for (OwnerForm of OwnerFormArray.controls; track OwnerForm) {
        <form
          class="row mb-3"
          [formGroup]="OwnerForm.controls['OwnerFinding']!"
        >
          <div class="col">
            <app-display-card>
              <div class="owner-card-head">
                <div>
                  <div class="owner-eyebrow">Owner background check</div>
                  <h3 class="mb-0">
                    {{ OwnerForm.controls['firstName'].value }}
                    {{ OwnerForm.controls['lastName'].value }}
                  </h3>
                </div>
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  (click)="runVerificationOnOwner(OwnerForm)"
                >
                  <i class="bi bi-shield-check me-1"></i>
                  Run public data
                </button>
              </div>

              <dl class="owner-meta">
                <div class="owner-meta__row">
                  <dt>Findings last updated</dt>
                  <dd>
                    {{
                      (OwnerForm.controls['OwnerFinding']!.controls['updatedAt']
                        .value | date: 'MM/dd/y') || '—'
                    }}
                  </dd>
                </div>
                @if (OwnerForm.controls['id'].value) {
                  <div class="owner-meta__row">
                    <dt>Last run date</dt>
                    <dd>
                      {{
                        (MappedOwners.get(OwnerForm.controls['id'].value!)!
                          .lastRanOwnerVerificationReportDate
                          | date: 'MM/dd/y') || '—'
                      }}
                    </dd>
                  </div>
                }
                <div class="owner-meta__row">
                  <dt>Lexis Nexis ID</dt>
                  <dd>
                    {{
                      MappedOwners.get(OwnerForm.controls['id'].value!)!
                        .LexisNexisId || '—'
                    }}
                  </dd>
                </div>
                @if (Vendor.hasOwnerReportData) {
                  <div class="owner-meta__row">
                    <dt>Raw data</dt>
                    <dd>
                      <button
                        type="button"
                        class="btn btn-ghost btn-sm p-0"
                        (click)="downloadRawDataReports(OwnerForm)"
                      >
                        <i class="bi bi-download me-1"></i>
                        Download
                      </button>
                    </dd>
                  </div>
                }
              </dl>

              <div class="owner-findings inner-panel rounded">
                <div class="owner-findings__head">
                  <div class="owner-findings__col owner-findings__col--check">
                    Check
                  </div>
                  <div class="owner-findings__col">Finding</div>
                  <div class="owner-findings__col owner-findings__col--center">
                    Level: {{ vendorRiskLevel || 'Global' }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    Result
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Identity check
                  </div>
                  <div class="owner-findings__col">
                    <select class="form-select" formControlName="ownerIdentity">
                      @for (
                        OwnerIdentityObject of OwnerIdentityValues;
                        track OwnerIdentityObject
                      ) {
                        <option [ngValue]="OwnerIdentityObject.value">
                          {{ OwnerIdentityObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{
                      ComplianceSetting.ownerIdentity ? 'Yes' : 'Not required'
                    }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{ getOwnerComplianceResult(OwnerForm, 'ownerIdentity') }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Watchlist
                  </div>
                  <div class="owner-findings__col">
                    <select
                      class="form-select"
                      formControlName="ownerWatchlist"
                    >
                      @for (
                        OwnerWatchlistObject of OwnerWatchlistValues;
                        track OwnerWatchlistObject
                      ) {
                        <option [ngValue]="OwnerWatchlistObject.value">
                          {{ OwnerWatchlistObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{ getOwnerWatchlistDisplayText() }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{
                        getOwnerComplianceResult(OwnerForm, 'ownerWatchlist')
                      }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Sex offender
                  </div>
                  <div class="owner-findings__col">
                    <select
                      class="form-select"
                      formControlName="ownerSexOffender"
                    >
                      @for (YesNoObject of YesNoValues; track YesNoObject) {
                        <option [ngValue]="YesNoObject.value">
                          {{ YesNoObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{ ComplianceSetting.ownerSexOffender ? 'Yes' : 'No' }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{
                        getOwnerComplianceResult(OwnerForm, 'ownerSexOffender')
                      }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Felonies
                  </div>
                  <div class="owner-findings__col">
                    <select class="form-select" formControlName="ownerFelony">
                      @for (
                        FelonyYearObject of FelonyYearValues;
                        track FelonyYearObject
                      ) {
                        <option [ngValue]="FelonyYearObject.value">
                          {{ FelonyYearObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{
                      getMisdemeanorOrFelonyDisplayText(
                        ComplianceSetting.ownerFelony
                      )
                    }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{ getOwnerComplianceResult(OwnerForm, 'ownerFelony') }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Misdemeanors
                  </div>
                  <div class="owner-findings__col">
                    <select
                      class="form-select"
                      formControlName="ownerMisdemeanor"
                    >
                      @for (
                        MisdemeanorYearObject of MisdemeanorYearValues;
                        track MisdemeanorYearObject
                      ) {
                        <option [ngValue]="MisdemeanorYearObject.value">
                          {{ MisdemeanorYearObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{
                      getMisdemeanorOrFelonyDisplayText(
                        ComplianceSetting.ownerMisdemeanor
                      )
                    }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{
                        getOwnerComplianceResult(OwnerForm, 'ownerMisdemeanor')
                      }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row">
                  <div class="owner-findings__col owner-findings__col--check">
                    Liens &amp; judgements
                  </div>
                  <div class="owner-findings__col">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="ownerLiens"
                    />
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{ getLiensDisplayText() }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{ getOwnerComplianceResult(OwnerForm, 'ownerLiens') }}
                    </span>
                  </div>
                </div>

                <div class="owner-findings__row owner-findings__row--last">
                  <div class="owner-findings__col owner-findings__col--check">
                    Bankruptcy
                  </div>
                  <div class="owner-findings__col">
                    <select
                      class="form-select"
                      formControlName="ownerBankruptcy"
                    >
                      @for (
                        BankruptcyObject of BankruptcyValues;
                        track BankruptcyObject
                      ) {
                        <option [ngValue]="BankruptcyObject.value">
                          {{ BankruptcyObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    {{ getBankruptcyRequirementLabel() }}
                  </div>
                  <div class="owner-findings__col owner-findings__col--center">
                    <span class="chip-host" appStatusStyleChanges>
                      {{
                        getOwnerComplianceResult(OwnerForm, 'ownerBankruptcy')
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="action-row justify-end mt-3">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="overrideOwnerFindings(OwnerForm)"
                >
                  Save findings
                </button>
              </div>
            </app-display-card>
          </div>
        </form>
      }

      <!-- Owner roster -->
      <div class="row">
        <div class="col">
          <app-display-card>
            <div class="owner-section-head">
              <h3 class="mb-0">Owners</h3>
              <span class="owner-section-count">
                {{ Owners.length }}
                {{ Owners.length === 1 ? 'owner' : 'owners' }}
              </span>
            </div>
            <div class="owner-roster-grid">
              @for (Owner of Owners; track Owner) {
                <div class="owner-roster-card">
                  <div class="owner-roster-card__head">
                    <div class="owner-roster-card__name">
                      {{ Owner.firstName }} {{ Owner.lastName }}
                    </div>
                    <span class="owner-roster-card__ownership">
                      {{ Owner.percentOwner }}% owner
                    </span>
                  </div>
                  <dl class="owner-roster-card__details">
                    <div class="owner-roster-card__row">
                      <dt>Phone</dt>
                      <dd>{{ Owner.phone || '—' }}</dd>
                    </div>
                    <div class="owner-roster-card__row">
                      <dt>DOB</dt>
                      <dd>
                        {{ (Owner.dob | date: 'MM/dd/y') || '—' }}
                      </dd>
                    </div>
                    <div class="owner-roster-card__row">
                      <dt>State</dt>
                      <dd>{{ Owner.Address!.state || '—' }}</dd>
                    </div>
                    @if (Owner.hasSSN) {
                      <div class="owner-roster-card__row">
                        <dt>SSN (first 5)</dt>
                        <dd>
                          @if (getRevealedOwnerSSN(Owner.id)) {
                            <span>{{ getRevealedOwnerSSN(Owner.id) }}</span>
                          } @else if (hasOwnerSSNAccess) {
                            <button
                              type="button"
                              class="btn btn-ghost btn-sm p-0"
                              (click)="viewOwnerSSN(Owner)"
                            >
                              View SSN
                            </button>
                          } @else {
                            <span>***-**</span>
                          }
                        </dd>
                      </div>
                    }
                  </dl>
                  <div
                    class="action-row justify-end owner-roster-card__actions"
                  >
                    <button
                      type="button"
                      class="btn btn-ghost btn-sm"
                      (click)="deleteOwner(Owner)"
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      (click)="editOwner(Owner)"
                    >
                      Edit
                    </button>
                  </div>
                </div>
              }
            </div>
          </app-display-card>
        </div>
      </div>
    }
  </div>
}
